import { render, staticRenderFns } from "./CreateDeal.vue?vue&type=template&id=15c39999&"
import script from "./CreateDeal.vue?vue&type=script&lang=js&"
export * from "./CreateDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports